import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetOption } from '../../../../../Widget.ts';
import {
  widgetOptionDividerValidator,
  widgetOptionValueValidator,
} from '../util/widgetOptionValidator.ts';

/**
 * Utilizza correttamente il validatore in base al tipo di option validata.
 */
export const widgetOptionValidator = yup.lazy(
  (value: IWidgetOption | undefined) => {
    if (!value || value.type === 'option') {
      return widgetOptionValueValidator;
    }
    return widgetOptionDividerValidator;
  },
);

export const widgetOptionArrayValidator = yup
  .array(widgetOptionValidator)
  .optional()
  .default([]);
